<template>
    <div class="guide-container"> 
        <DeviceCard host="guide"></DeviceCard>
        
        <!-- 搜索区域 -->
        <div class="search-section">
            <van-search
                v-model="searchValue"
                placeholder="请输入型号关键词"
                shape="round"
                show-action
                @search="onSearch"
                @cancel="onCancel"
                class="search-box"
            >
                <template #action>
                    <div @click="onSearch" class="search-action">搜索</div>
                </template>
            </van-search>
        </div>

        <!-- 内容区域 -->
        <div class="content-section">
            <!-- 结果统计 -->
            <div v-if="hasDocuments" class="result-count">
                <van-icon name="search" class="count-icon" />
                共找到 {{ totalDocuments }} 个文档
            </div>

            <!-- 安装指南 -->
            <div v-if="hasGuides" class="doc-section">
                <div class="section-header">
                    <van-icon name="star" class="section-icon" />
                    <span class="section-title">安装指南</span>
                    <van-badge :content="guideNumber" max="99" class="section-badge" />
                </div>
                <div class="doc-list">
                    <div 
                        class="doc-card" 
                        v-for="item in guidelist" 
                        :key="item.RecID"
                        @click="handleGuideClick(item.ViewURL)"
                    >
                        <div class="doc-header">
                            <van-icon name="description" class="doc-icon" />
                            <div class="doc-info">
                                <h4 class="doc-title">{{ item.FileCaption }}</h4>
                                <p class="doc-detail">{{ item.detail }}</p>
                            </div>
                            <van-icon name="arrow" class="arrow-icon" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 用户手册 -->
            <div v-if="hasManuals" class="doc-section">
                <div class="section-header">
                    <van-icon name="label" class="section-icon" />
                    <span class="section-title">用户手册</span>
                    <van-badge :content="manualNumber" max="99" class="section-badge" />
                </div>
                <div class="doc-list">
                    <div 
                        class="doc-card" 
                        v-for="item in manuallist" 
                        :key="item.RecID"
                        @click="handleManualClick(item.ViewURL)"
                    >
                        <div class="doc-header">
                            <van-icon name="book" class="doc-icon" />
                            <div class="doc-info">
                                <h4 class="doc-title">{{ item.FileCaption }}</h4>
                                <p class="doc-detail">{{ item.detail }}</p>
                            </div>
                            <van-icon name="arrow" class="arrow-icon" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="!hasDocuments" class="empty-state">
                <van-empty description="请输入关键词搜索产品文档" image="search">
                    <div class="search-tips">
                        <van-icon name="info" class="tip-icon" />
                        <p>可以输入关键词查询</p>
                    </div>
                </van-empty>
            </div>
        </div>
    </div>
</template>
   
<script>
// @ is an alias to /src
import Vue from 'vue'
import 'vant/lib/icon/local.css';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import { Dialog } from 'vant';
import { Toast } from 'vant'
import global from '../../components/global.vue';
import DeviceCard from '../../components/devicecard.vue';

// 常量定义
const API_BASE_URL = 'https://t3.lenovoimage.com/api/Web2/productinfolist';
const MESSAGES = {
    SEARCH_FAILED: '搜索失败，请重试',
    GUIDE_TIP_TITLE: '温馨提示',
    GUIDE_TIP_MESSAGE: '点击直接查看安装指南',
    MANUAL_TIP_TITLE: '温馨提示',
    MANUAL_TIP_MESSAGE: '点击直接查看用户手册',
    CONFIRM_TEXT: '直接查看'
};

export default {
    name: 'ShowArticle',   
    components: {
        DeviceCard,
    },
    data() {
        return {	
            keyword: '',            
            manuallist: [],	
            guidelist: [],
            productlines: [],
            searchValue: '',
            Driver: require("@/assets/driver2.png"),
            rows: 0,
            guideNumber: 0,
            manualNumber: 0,
            models: '',
            sns: ''
        };
    },
    
    computed: {
        /**
         * 检查是否有安装指南
         */
        hasGuides() {
            return this.guidelist && this.guidelist.length > 0;
        },
        
        /**
         * 检查是否有用户手册
         */
        hasManuals() {
            return this.manuallist && this.manuallist.length > 0;
        },
        
        /**
         * 检查是否有任何文档
         */
        hasDocuments() {
            return this.hasGuides || this.hasManuals;
        },
        
        /**
         * 计算文档总数
         */
        totalDocuments() {
            return this.guidelist.length + this.manuallist.length;
        }
    },
    
    created() {
        this.initDocumentData();

    },
    mounted(){
        document.title = '手册指南';
    },
    methods: {	
        /**
         * 初始化文档数据
         */
        initDocumentData() {
              this.devicesList = global.devicesList || [];
                if (this.devicesList.length > 0) {
                    this.pn = this.devicesList[0].ProductCode || '';
                    this.models = this.devicesList[0].Model || '';
                    this.searchValue = this.models;
                    this.keyword = this.models;
                    console.log(this.models, 'models');
                    this.getDocumentList();
                }
          
        },
        
        /**
         * 搜索处理
         */
        onSearch() {
            this.keyword = this.searchValue.trim();
            console.log('搜索关键词:', this.keyword);
            this.getDocumentList();	
        },
        
        /**
         * 取消搜索
         */
        onCancel() {
            this.manuallist = [];
            this.guidelist = [];
            this.searchValue = '';
        },
        
        /**
         * 获取文档列表
         */
        getDocumentList() {
            const that = this;
            const params = `appid=svchome&keywords=${this.keyword}&sn=${this.sns}`;
            
            Vue.axios.get(`${API_BASE_URL}?${params}`)
                .then(function(response) {
                    that.handleDocumentResponse(response);
                })
                .catch(function(error) {
                    that.handleDocumentError(error);
                });
        },
        
        /**
         * 处理文档响应
         */
        handleDocumentResponse(response) {
            console.log(response, 'response');
            if (response.data.Status === "0") {
                const data = response.data.Data;
                this.updateDocumentData(data);
            } else {
                this.clearDocumentData();
            }
        },
        
        /**
         * 更新文档数据
         */
        updateDocumentData(data) {
            this.manuallist = data.Table2 || [];
            this.manualNumber = this.manuallist.length;
            this.guidelist = data.Table3 || [];
            this.guideNumber = this.guidelist.length;
            
            console.log(this.manuallist, 'manuallist');
        },
        
        /**
         * 清空文档数据
         */
        clearDocumentData() {
            this.manuallist = [];
            this.guidelist = [];
            this.manualNumber = 0;
            this.guideNumber = 0;
        },
        
        /**
         * 处理文档错误
         */
        handleDocumentError(error) {
            console.log(error);
            this.clearDocumentData();
            Toast(MESSAGES.SEARCH_FAILED);
        },
        
        /**
         * 处理安装指南点击
         */
        handleGuideClick(viewUrl) {
            this.showViewDialog(
                MESSAGES.GUIDE_TIP_TITLE,
                MESSAGES.GUIDE_TIP_MESSAGE,
                viewUrl
            );
        },
        
        /**
         * 处理用户手册点击
         */
        handleManualClick(viewUrl) {
            this.showViewDialog(
                MESSAGES.MANUAL_TIP_TITLE,
                MESSAGES.MANUAL_TIP_MESSAGE,
                viewUrl
            );
        },
        
        /**
         * 显示查看对话框
         */
        showViewDialog(title, message, viewUrl) {
            Dialog.confirm({
                title: title,
                message: message,
                confirmButtonText: MESSAGES.CONFIRM_TEXT,
                showCancelButton: false
            }).then(() => {
                this.navigateToPDF(viewUrl);
            });
        },
        
        /**
         * 跳转到PDF页面
         */
        navigateToPDF(viewUrl) {
            this.$router.push({ 
                path: '/productinfo/openPDF',
                query: { pdfurl: viewUrl }
            });
        },
        
        /**
         * 返回首页
         */
        onClickLeft() {
            this.$router.push({ path: '/' });
        }
    }
}
</script>

<style scoped>
.guide-container {
    background-color: #f7f8fa;
    min-height: 100vh;
}

.search-section {
    background-color: #ffffff;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.search-box {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
}

.search-action {
    color: #1989fa;
    font-size: 14px;
    padding: 0 8px;
}

.content-section {
    padding: 16px;
    background-color: #f7f8fa;
    min-height: 50vh;
}

.result-count {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
}

.count-icon {
    margin-right: 8px;
    font-size: 16px;
}

.doc-section {
    margin-bottom: 24px;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding: 12px 0;
    border-bottom: 2px solid #f0f0f0;
}

.section-icon {
    color: #1989fa;
    font-size: 18px;
    margin-right: 8px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-right: 8px;
}

.section-badge {
    margin-left: auto;
}

.doc-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.doc-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
}

.doc-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.doc-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.doc-icon {
    color: #1989fa;
    font-size: 20px;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
}

.doc-info {
    flex: 1;
    min-width: 0;
}

.doc-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-all;
}

.doc-detail {
    font-size: 13px;
    color: #969799;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.arrow-icon {
    color: #969799;
    font-size: 14px;
    margin-left: 8px;
    flex-shrink: 0;
    margin-top: 2px;
}

.empty-state {
    padding: 40px 20px;
}

.search-tips {
    text-align: center;
    margin-top: 16px;
}

.tip-icon {
    color: #969799;
    font-size: 16px;
    margin-bottom: 8px;
}

.search-tips p {
    font-size: 14px;
    color: #969799;
    margin: 0;
}
</style>